module.exports = function (app) {

    app
        .controller('pages.ndRegistration', ['$scope', '$state', 'services', '$cookies', 'brand','$filter','modal', 'registration','$window',
        function ($scope, $state, services, cookies, brand,$filter, modal,registration,$window) {
            var theBrand = brand.current.sharedBrandCode.toLowerCase();
            window.$scope= $scope;
            $scope.phoneType = { value: '' };
            $scope.relationshipToHolder = { value: '' };
            $scope.disableCheck = false;
            $scope.disableButtons = false;
            $scope.campaignID ='';
            $scope.userType = '';
            $scope.login ={};


            $scope.content = require("./ndregistration/errorContent.json");


            $scope.disableCheck = false;

            $scope.submitForm = function (formName) {
                console.log(" registration form", formName);

                if (formName && formName.$valid) {
                    var formFields = formName.ndForm;
                    $scope.user = {
                        addressLine1: formFields.stAddress.$modelValue,
                        birthDate: $filter('date')(formFields.dob.$modelValue, 'MM/dd/yyyy'),
                        brand: theBrand,
                        city: formFields.cityName.$modelValue,
                        email: formFields.userEmail.$modelValue,
                        firstName: formFields.firstName.$modelValue,
                        lastName: formFields.lastName.$modelValue,
                        memberId: formFields.memberID.$modelValue,
                        phoneNumber: formFields.phoneNumber.$modelValue ? formFields.phoneNumber.$modelValue : '',
                        phoneType: formFields.phoneType.$modelValue !== undefined ? formFields.phoneType.$modelValue.value : '',
                        relCode: formFields.relationshipToHolder.$modelValue.value,
                        zipCode: formFields.zipCode.$modelValue

                    };
                    $scope.stAddress = angular.copy(formFields.stAddress.$modelValue);
                    $scope.dob = angular.copy(formFields.dob.$modelValue);
                    $scope.cityName = angular.copy(formFields.cityName.$modelValue);
                    $scope.userEmail = angular.copy(formFields.userEmail.$modelValue);
                    $scope.firstName = angular.copy(formFields.firstName.$modelValue);
                    $scope.lastName = angular.copy(formFields.lastName.$modelValue);
                    $scope.memberID = angular.copy(formFields.memberID.$modelValue);
                    $scope.phoneNumber = formFields.phoneNumber.$modelValue ? angular.copy(formFields.phoneNumber.$modelValue) : '';
                    $scope.phoneType.value = formFields.phoneType.$modelValue != undefined ? angular.copy(formFields.phoneType.$modelValue.value) : '';
                    $scope.relationshipToHolder.value = angular.copy(formFields.relationshipToHolder.$modelValue.value);
                    $scope.zipCode = angular.copy(formFields.zipCode.$modelValue);
                    $scope.repeatEmail = angular.copy(formFields.repeatEmail.$modelValue);
                    $scope.memberInfo = angular.copy($scope.user);
                    $scope.completeStep = true;
                    $scope.disableCheck = true;

                    services.rbsmbl.consumerProfile().checkProfile($scope.user).then(function (data) {
                        //$scope.user = data.user;
                        //var stateParams =  { user : $scope.user };
                        //stateParams.identifyResponse = data.response;
                        console.log("data", data);

                        $scope.disableCheck = false;
                        $state.go('registration.createLogin');


                        // $window.location = "/member/registration/createLogin";

                    }, function (error) {
                        console.log("error", error);
                        var returnCodeDescription = error.data.baseMessage.returnCodeDescription;
                        switch (returnCodeDescription) {

                            case 'GEN-CONFCOMM':

                                modal.open({
                                    heading: $scope.content.modalContent.confidentialCommunication.title,
                                    template: '<p>{{contentThis.modalContent.confidentialCommunication.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.contentThis = require("./ndregistration/errorContent.json");
                                    }]
                                });

                                break;

                            case 'MIN-AGE':

                                modal.open({
                                    heading: $scope.content.modalContent.minimumAgeFailure.title,
                                    template: '<p>{{contentThis.modalContent.minimumAgeFailure.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.contentThis = require("./ndregistration/errorContent.json");
                                    }]
                                });

                                break;

                            case 'CP-SEARCH-FAILURE':

                                modal.open({
                                    heading: $scope.content.modalContent.cpSearchFailure.title,
                                    template: '<p>{{contentThis.modalContent.cpSearchFailure.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.contentThis = require("./ndregistration/errorContent.json");
                                    }]
                                });

                                break;

                            case 'CP-UPDATE-FAILURE':

                                modal.open({
                                    heading: $scope.content.modalContent.cpUpdateFailure.title,
                                    template: '<p>{{contentThis.modalContent.cpUpdateFailure.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.contentThis = require("./ndregistration/errorContent.json");
                                    }]
                                });

                                break;

                            case 'CP-GEN-FAILURE':

                                modal.open({
                                    heading: $scope.content.modalContent.cpGenFailure.title,
                                    template: '<p>{{content.modalContent.cpGenFailure.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.content = require("./ndregistration/errorContent.json");
                                    }]
                                });

                                break;

                            case 'UXP-DEFAULT':

                                modal.open({
                                    heading: $scope.content.modalContent.unexpectedError.title,
                                    template: '<p>{{content.modalContent.unexpectedError.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.content = require("./ndregistration/errorContent.json");
                                    }]
                                });

                                break;

                            case 'GEN-NOMATCHREG':

                                modal.open({
                                    heading: $scope.content.modalContent.noMatchMemberRegister.title,
                                    template: '<p>{{content.modalContent.noMatchMemberRegister.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.content = require("./ndregistration/errorContent.json");
                                    }]
                                });

                                break;

                            case 'EMAIL-EXISTS':

                                modal.open({
                                    heading: $scope.content.modalContent.duplicateEmail.title,
                                    template: '<p>{{content.modalContent.duplicateEmail.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.content = require("./ndregistration/errorContent.json");
                                    }]
                                });

                                break;

                            case 'EMAIL-HM':

                                modal.open({
                                    heading: $scope.content.modalContent.reservedEmail.title,
                                    template: '<p>{{content.modalContent.reservedEmail.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.content = require("./ndregistration/errorContent.json");
                                    }]
                                });
                                break;

                            case 'EMAIL-HM-EXISTS':

                                modal.open({
                                    heading: $scope.content.modalContent.reservedAndExistsEmail.title,
                                    template: '<p>{{content.modalContent.reservedAndExistsEmail.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.content = require("./ndregistration/errorContent.json");
                                    }]
                                });
                                break;

                            default:
                                modal.open({
                                    heading: $scope.content.modalContent.unexpectedError.title,
                                    template: '<p>{{content.modalContent.unexpectedError.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.content = require("./ndregistration/errorContent.json");
                                    }]
                                });

                        }

                        //modal.open({
                        //    template: error.data
                        //});
                        $scope.disableCheck = false;
                        $scope.completeStep = false;

                        //$window.location = "/member/registration";
                    });
                }
            };
            $scope.backButton = function() {
                //$window.open('/member/registration', '_self');
                //$state.go(previousState);
                    $state.go('registration.memberInformation');

            };
            $scope.loginSubmit = function(loginForm){

                console.log(" registration form", loginForm);
                if (loginForm && loginForm.$valid) {
                    $scope.memberInfo.username = loginForm.username.$modelValue;
                    $scope.memberInfo.password = loginForm.newPassword.$modelValue;
                    $scope.memberInfo.securityQuestion = loginForm.newSecurityQuestionSelect.$modelValue.value;
                    $scope.memberInfo.securityAnswer = loginForm.secAns.$modelValue;
                    console.log(" on create login", $scope.memberInfo);
                    $scope.disableButtons = true;
                    // register user
                    registration.oldRegister($scope.memberInfo).then( function(response){

                        //login user
                        registration.loginMember($scope.memberInfo, $scope.campaignID, $scope.userType).then( function(response) {
                            //Login success, user will be directed to member landing or campaign page.
                            coremetrics.finishConversion('MEMBER REGISTRATION LOGIN', 'REGISTRATION');
                            $scope.disableButtons = false;

                        }, function(error) {
                            $scope.disableButtons = false;
                            $scope.currentNotification = registration.notifications.registerPassLoginFail;
                        });
                    console.log(response);
                    }, function(error) {
                        $scope.disableButtons = false;
                        console.log("error",error);
                        var returnCodeDescription = error.returnCodeDescription;
                        switch (returnCodeDescription) {

                            case 'GEN-INVALIDLOGINID':

                                modal.open({
                                    heading: $scope.content.modalContent.invalidLoginID.title,
                                    template: '<p>{{contentThis.modalContent.invalidLoginID.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.contentThis = require("./ndregistration/errorContent.json");
                                    }]
                                });

                                break;

                            case 'DUP-LOGIN':

                                modal.open({
                                    heading: $scope.content.modalContent.duplicateLogin.title,
                                    template: '<p>{{contentThis.modalContent.duplicateLogin.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.contentThis = require("./ndregistration/errorContent.json");
                                    }]
                                });

                                break;

                            case 'UPD-LDAP':

                                modal.open({
                                    heading: $scope.content.modalContent.ldapError.title,
                                    template: '<p>{{contentThis.modalContent.ldapError.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.contentThis = require("./ndregistration/errorContent.json");
                                    }]
                                });

                                break;

                            case 'DUP-REGISTERED':

                                modal.open({
                                    heading: $scope.content.modalContent.alreadyRegistered.title,
                                    template: '<p>{{contentThis.modalContent.alreadyRegistered.message}}</p>' +
                                    '<p class="text-r"><button data-ng-click="redirectLogin()" class="action-btn">Continue</button></p>',
                                    controller: ["$scope","$window", function ($scope,$window) {
                                        $scope.contentThis = require("./ndregistration/errorContent.json");
                                        $scope.redirectLogin = function(){
                                            $window.location = '/member/home';
                                        }
                                    }]
                                });

                                break;

                            default:
                                modal.open({
                                    heading: $scope.content.modalContent.unexpectedError.title,
                                    template: '<p>{{contentThis.modalContent.unexpectedError.message}}</p>',
                                    controller: ["$scope", function ($scope) {
                                        $scope.contentThis = require("./ndregistration/errorContent.json");
                                    }]
                                });

                        }

                    });
                }
            };

            $scope.headings = "REGISTER";
            $scope.sidebar.links = [];
            $scope.ndShowMbrInfo = true;

            $scope.completeStep =false;


            if ($scope.ndShowMbrInfo) {
                $scope.sidebar.links.push({
                    heading: '<span class="ndRegisterSidebar"> GET THE MOST FROM YOUR MEMBERSHIP</span>',
                    label: '<span>Member Information</span><span data-ng-if="completeStep" class="hm-icon icon-approved checkIcon"></span>',
                    state: "registration.memberInformation",
                    description: '<span class="ndSidebarDesc">You&apos;ve made a good choice about your coverage&excl; Take this next step to get personalized information about your coverage and claims&comma; sign up for special programs and learn more about staying healthy.</span>'
                });
            }

                $scope.sidebar.links.push({
                    heading: '<span class="ndRegisterSidebar">GET THE MOST FROM YOUR MEMBERSHIP</span>',
                    label: 'Create Login',
                    state: "registration.createLogin",
                    inActive: true,
                    description: '<span class="ndSidebarDesc">You&apos;ve made a good choice about your coverage&excl; Take this next step to get personalized information about your coverage and claims&comma; sign up for special programs and learn more about staying healthy.</span>'
                });


        }])


};
